module.exports = __webpack_public_path__ + "img/happytablet_product2.883c7adc.jpg";